// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import {
  Box,
  SpaceBetween,
} from '@cloudscape-design/components';
import { PERSISTENT_METHOD_CARDS } from './constants';

const getCardStyle = (isSelected) => ({
  border: isSelected ? '2px solid #0972d3' : '2px solid #d5dbdb',
  borderRadius: '12px',
  cursor: 'pointer',
  backgroundColor: isSelected ? '#f2f8fd' : '#ffffff',
  transition: 'all 0.15s ease-in-out',
  padding: '20px',
  flex: '1 1 0',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
});

const PersistentSubSelector = ({ selectedPersistentMethod, onSelect }) => {
  return (
    <SpaceBetween size="m">
      <Box variant="p" color="text-body-secondary" textAlign="center">
        Choose your preferred infrastructure tool for persistent onboarding
      </Box>
      <div
        style={{
          display: 'flex',
          gap: '20px',
          maxWidth: '1100px',
          margin: '0 auto',
          alignItems: 'stretch',
        }}
      >
        {Object.entries(PERSISTENT_METHOD_CARDS).map(([key, card]) => (
          <div
            key={key}
            style={getCardStyle(selectedPersistentMethod === key)}
            onClick={() => onSelect(key)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(key);
              }
            }}
            aria-pressed={selectedPersistentMethod === key}
          >
            <Box variant="h3" padding={{ bottom: 'xxs' }}>
              {card.title}
            </Box>
            <Box variant="p" color="text-body-secondary">
              {card.description}
            </Box>
          </div>
        ))}
      </div>
    </SpaceBetween>
  );
};

export default PersistentSubSelector;
